/*
 *
 * ActivityReviewsPage actions
 *
 */

const SCOPE = 'app/ActivityReviewsPage/';
export const ActionTypes = {
    RESET_CONTENTS: `${SCOPE}RESET_CONTENTS`,
    SET_PARAMS: `${SCOPE}SET_PARAMS`,
    SET_IS_404: `${SCOPE}SET_IS_404`,

    SET_PAGE_IS_LOADED: `${SCOPE}SET_PAGE_IS_LOADED`,
    FETCH_PAGE: `${SCOPE}FETCH_PAGE`,
    FETCH_PAGE_STARTED: `${SCOPE}FETCH_PAGE_STARTED`,
    FETCH_PAGE_SUCCESSFULLY: `${SCOPE}FETCH_PAGE_SUCCESSFULLY`,
    FETCH_PAGE_FAILED: `${SCOPE}FETCH_PAGE_FAILED`,
    FETCH_PAGE_CANCELLED: `${SCOPE}FETCH_PAGE_CANCELLED`,

    SET_REVIEWS_IS_LOADED: `${SCOPE}SET_REVIEWS_IS_LOADED`,
    SET_REVIEWS_HAS_MORE: `${SCOPE}SET_REVIEWS_HAS_MORE`,
    FETCH_REVIEWS: `${SCOPE}FETCH_REVIEWS`,
    RESET_REVIEWS: `${SCOPE}RESET_REVIEWS`,
    FETCH_REVIEWS_STARTED: `${SCOPE}FETCH_REVIEWS_STARTED`,
    FETCH_REVIEWS_SUCCESSFULLY: `${SCOPE}FETCH_REVIEWS_SUCCESSFULLY`,
    FETCH_REVIEWS_FAILED: `${SCOPE}FETCH_REVIEWS_FAILED`,
    FETCH_REVIEWS_CANCELLED: `${SCOPE}FETCH_REVIEWS_CANCELLED`,
};

/**
 * Common
 */
export const setIs404 = (is404) => ({
    type: ActionTypes.SET_IS_404,
    is404,
});

export const setParams = (params) => ({
    type: ActionTypes.SET_PARAMS,
    params,
});

export const resetContents = () => ({ type: ActionTypes.RESET_CONTENTS });

/**
 * Page
 */
export const setPageIsLoaded = (isLoaded) => ({ type: ActionTypes.SET_PAGE_IS_LOADED, isLoaded });
export const fetchPage = () => ({ type: ActionTypes.FETCH_PAGE });
export const fetchPageStarted = () => ({ type: ActionTypes.FETCH_PAGE_STARTED });
export const fetchPageSuccessfully = (res) => ({
    type: ActionTypes.FETCH_PAGE_SUCCESSFULLY,
    res,
});
export const fetchPageFailed = (error) => ({
    type: ActionTypes.FETCH_PAGE_FAILED,
    error,
});
export const fetchPageCancelled = () => ({
    type: ActionTypes.FETCH_PAGE_CANCELLED,
});

/**
 * Reviews
 */
export const setReviewsIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_REVIEWS_IS_LOADED,
    isLoaded,
});
export const setReviewsHasMore = (hasMore) => ({
    type: ActionTypes.SET_REVIEWS_HAS_MORE,
    hasMore,
});
export const fetchReviews = () => ({ type: ActionTypes.FETCH_REVIEWS });
export const resetReviews = () => ({ type: ActionTypes.RESET_REVIEWS });
export const fetchReviewsStarted = () => ({ type: ActionTypes.FETCH_REVIEWS_STARTED });
export const fetchReviewsSuccessfully = (res) => ({
    type: ActionTypes.FETCH_REVIEWS_SUCCESSFULLY,
    res,
});
export const fetchReviewsFailed = (error) => ({
    type: ActionTypes.FETCH_REVIEWS_FAILED,
    error,
});
export const fetchReviewsCancelled = () => ({
    type: ActionTypes.FETCH_REVIEWS_CANCELLED,
});
